import { createRouter, createWebHistory } from 'vue-router'
import { auth } from '../firebaseConfig.js'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import LabelledInput from '../components/LabelledInput.vue'
import CaseReportHome from '../views/CaseReportHome.vue'

const routes = [
  {
    path: '/:pathMatch(.*)*',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/casereport',
    name: 'CaseReportHome',
    component: CaseReportHome,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/test',
    name: 'Test',
    component: LabelledInput
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const currentUser = auth.currentUser

  if (requiresAuth && !currentUser) {
    next('/login')
  } else {
    next()
  }
})

export default router
